import { Export } from '../ExportCompound';

export const CurrentView = (): React.ReactNode => {
  return (
    <div data-testid="current-view-tab">
      <Export>
        <p>The entire diagram area will be exported, including the part under the left panel</p>
        <Export.DownloadCurrentView />
      </Export>
    </div>
  );
};
